module.exports = __webpack_public_path__ + "img/chronext-logo.d4232aa6.svg";